import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d9e8c966")

_pushScopeId("data-v-d9e8c966")
const _hoisted_1 = {
  class: "home-page",
  style: {"height":"calc(100vh - 147px)"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("iframe", {
      id: "honor-cloud-design",
      width: "100%",
      height: "100%",
      frameborder: "0",
      src: _ctx.url,
      ref: "iframe",
      marginwidth: "0",
      marginheight: "0",
      vspace: "0",
      hspace: "0",
      allowtransparency: "true",
      allowfullscreen: "true"
    }, "\n    ", 8, ["src"])
  ]))
})